import { Pipe, PipeTransform } from '@angular/core';
import { Booking } from '../../models/booking';
import { Docket } from '../../models';
import { SaleDocket } from '../../models/sale-docket';
import { RepairDocket } from '../../models/repair-docket';

@Pipe({
    name: 'documentTitle',
    standalone: true
})
export class DocumentTitlePipe implements PipeTransform {
  transform(
    value: Docket | Booking | SaleDocket | RepairDocket,
    type: 'docket' | 'booking' | 'saleDocket' | 'repairDocket'
  ): string {
    if (type === 'docket') {
      const docket = value as Docket;
      if (docket.account_reference) {
        return `Invoice ${docket.account_reference}`;
      }
      return `Hire Contract ${value.id}`;
    }
    if (type === 'booking') {
      return `Booking ${value.id}`;
    }
    if (type === 'saleDocket') {
      const saleDocket = value as SaleDocket;
      if (saleDocket.account_reference) {
        return `Sales Invoice ${saleDocket.account_reference}`;
      }
      return `Draft Sales Invoice ${value.id}`;
    }
    if (type === 'repairDocket') {
      const repairDocket = value as RepairDocket;
      if (repairDocket.account_reference) {
        return `Repair Invoice ${repairDocket.account_reference}`;
      }
      return `Draft Repair Invoice ${value.id}`;
    }
  }
}
